<!-- =========================================================================================
  File Name: TeacherEditTabInformation.vue
  Description: Teacher Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="mb-4 vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="teacher_data.photo" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ teacher_data.name  }}( {{ teacher_data.teacherID  }} )</p>
            <input type="file" class="hidden" ref="update_photo_input" @change="update_photo" accept="image/*">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button class="mb-4" color="rgb(62, 201, 214)">파일선택</vs-button>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">

        <vs-input class="w-full mt-4" label="휴대폰번호" v-model="teacher_data.mobilephone "  name="mobilephone" />
        <span class="text-danger text-sm" v-show="errors.has('mobilephone')">{{ errors.first('mobilephone') }}</span>

        <vs-input class="w-full mt-4 mb-4" label="전화번호" v-model="teacher_data.telephone" name="telephone" />
        <span class="text-danger text-sm" v-show="errors.has('telephone')">{{ errors.first('telephone') }}</span>

        <vs-input class="w-full mt-4 mb-4" label="주민등록번호" v-model="teacher_data.realJumin" name="realJumin" />
        <span class="text-danger text-sm" v-show="errors.has('realJumin')">{{ errors.first('realJumin') }}</span>

        <label class="mt-4 ml-2 text-sm">생년월일</label>
        <div class="flex">
          <div class="w-1/3 bg-grid-color-secondary h-12">
            <datepicker :language="languages.ko" @selected="formatterBirthDay" v-model="teacher_data.birthDay" format="yyyy-MM-dd"></datepicker>
            <span class="text-danger text-sm"></span>
          </div>
          <div class="ml-4 w-1/3 bg-grid-color h-12">
            <div>
              <vs-select v-model="teacher_data.isLunar" label="" class="w-full" name="item-isLunar" >
                <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in isLunarOptions" />
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('item-isLunar')">{{ errors.first('item-isLunar') }}</span>
            </div>
          </div>
          <div class="ml-4 w-1/3 bg-grid-color h-12">
            <div>
              <vs-select v-model="teacher_data.gender" label="" class="w-full" name="item-gender" >
                <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in genderOptions" />
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('item-gender')">{{ errors.first('item-gender') }}</span>
            </div>
          </div>
        </div>
          <!-- <div class="mt-2 ml-4 w-1/3 bg-grid-color h-12">
            <div>
              <vs-radio v-model="teacher_data.isLunar" vs-value="0" class="mr-4">양력</vs-radio>
              <vs-radio v-model="teacher_data.isLunar" vs-value="1" class="mr-4">음력</vs-radio>
            </div>
          </div>
          <div class="mt-2 w-1/3 bg-grid-color-secondary h-12">
            <div>
              <vs-radio v-model="teacher_data.gender" vs-value="0" class="mr-4">남</vs-radio>
              <vs-radio v-model="teacher_data.gender" vs-value="1" class="mr-4">여</vs-radio>
            </div>
          </div> -->

        <vs-input class="w-full mt-4" label="이메일" v-model="teacher_data.eMail" type="email" v-validate="'required|email'" name="eMail" />
        <span class="text-danger text-sm" v-show="errors.has('eMail')">{{ errors.first('eMail') }}</span>

        <div class="flex flex-wrap mt-4">
          <div class="w-1/2">
            <vs-input class="w-full" label="우편번호" disabled v-model="teacher_data.zipCode" name="zipCode" />
            <span class="text-danger text-sm" v-show="errors.has('zipCode')">{{ errors.first('zipCode') }}</span>
          </div>
          <div class="w-1/2">
            <vs-button class="mt-5 ml-4" @click="popupActive=true">주소 검색</vs-button>
          </div>
        </div>
       
        <vs-input class="w-full mt-4" label="주소" disabled v-model="teacher_data.zipName" name="zipName" />
        <span class="text-danger text-sm" v-show="errors.has('zipName')">{{ errors.first('zipName') }}</span>

        <vs-input class="w-full mt-4" label="주소세부" v-model="teacher_data.zipDetail" name="zipDetail" />
        <span class="text-danger text-sm" v-show="errors.has('zipDetail')">{{ errors.first('zipDetail') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">         
        <!-- <vs-input class="w-full mt-4" label="Class 정보" v-model="teacher_data.classSeq"  name="classSeq" />
        <span class="text-danger text-sm" v-show="errors.has('classSeq')">{{ errors.first('classSeq') }}</span> -->

        <vs-select v-model="teacher_data.instituteSeq" label="소속" class="mt-4 w-full" name="item-instituteSeq" >
          <vs-select-item :key="item.instituteSeq" :value="item.instituteSeq" :text="item.instituteName" v-for="item in instituteOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-instituteSeq')">{{ errors.first('item-instituteSeq') }}</span>
  
        <vs-input class="w-full mt-4" label="주요경력" v-model="teacher_data.majorCareer"  name="majorCareer" />
        <span class="text-danger text-sm" v-show="errors.has('majorCareer')">{{ errors.first('majorCareer') }}</span>

        <vs-input class="w-full mt-4" label="교사경력" v-model="teacher_data.teacherCareer"  name="teacherCareer" />
        <span class="text-danger text-sm" v-show="errors.has('teacherCareer')">{{ errors.first('teacherCareer') }}</span>

        <vs-input class="w-full mt-4" label="졸업학교" v-model="teacher_data.university"  name="university" />
        <span class="text-danger text-sm" v-show="errors.has('university')">{{ errors.first('university') }}</span>
       
        <vs-input class="w-full mt-4" label="전공" v-model="teacher_data.subject"  name="subject" />
        <span class="text-danger text-sm" v-show="errors.has('subject')">{{ errors.first('subject') }}</span>
       
        <vs-select v-model="teacher_data.userType" label="교직원 타입" class="mt-4 w-full" name="item-userType" >
          <vs-select-item :key="item.userType" :value="item.userType" :text="item.description" v-for="item in userTypeOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-userType ')">{{ errors.first('item-userType ') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSaveChanges" :disabled="!validateForm">수정</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>

    <!-- Daum 우편번호 서비스 -->
    <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
      <p>
        <vue-daum-postcode @complete="this.daumPostCode" />
      </p>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'
import moment from 'moment'
import { VueDaumPostcode } from 'vue-daum-postcode'

import { fetchData, putData } from '@/api/module'

export default {
  components: {
    vSelect,
    Datepicker,
    VueDaumPostcode
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return { 
      languages: lang,
      popupActive: false,
      teacher_data: JSON.parse(JSON.stringify(this.data)),
      birthDay: this.data.birthDay,
      instituteOptions: [],
      userTypeOptions: [],
      statusOptions: [
        {
          value: 0,
          text: '정상'
        },
        {
          value: 1,
          text: '탈퇴'
        }
      ],
      isLunarOptions: [
        {
          value: 0,
          text: '양력'
        },
        {
          value: 1,
          text: '음력'
        }
      ],
      genderOptions: [
        {
          value: 0,
          text: '남'
        },
        {
          value: 1,
          text: '여'
        }
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    formatterBirthDay (value) {
      
      const birthDay = moment(value).format('YYYY-MM-DD')
      this.birthDay = birthDay
    },
    daumPostCode (value) {
      // console.log(`result: ${JSON.stringify(value)}`)
      this.teacher_data.zipCode = value.zonecode
      this.teacher_data.zipName = value.address

      this.popupActive = false
    },
    update_photo () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    confirmSaveChanges () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '교직원 정보 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    async saveChanges () {
      if (!this.validateForm) return

      this.teacher_data.birthDay = this.birthDay

      try {
        const { data } = await putData('teacher', this.teacher_data)
        console.log(data)

        const teacherID = this.teacher_data.teacherID
        this.$router.push(`/teacher/teacher-view/${teacherID}`)
        this.showSaveChangesSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '교직원 정보 수정',
        text: '저장 되었습니다.'
      })
    },
    reset_data () {
      this.teacher_data = JSON.parse(JSON.stringify(this.data))
    },
    async loadInstitutes () {
      try {
        const keyword = ''
        const institutes = await fetchData('institute/search', keyword)
        this.instituteOptions = institutes.data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadUserType () {
      try {
        const userTypes = await fetchData('member-type')
        this.userTypeOptions = userTypes.data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.loadInstitutes()
    this.loadUserType()
  }
}
</script>
